import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
export default {
  computed: {
    _validEvents() {
      return ["refresh", "pre-fetch", "sync", "request-sync", "navigate-validation-rule", "dismiss-validations"];
    },
    _widgetPopoverInstance: {
      get() {
        return this.$root.widgetPopover;
      },
      set(value) {
        this.$root.widgetPopover = value;
      }
    }
  },
  data() {
    return {
      _closeWidgetOnExit: true
    };
  },
  beforeMount() {
    this._closeWidgetOnExit = true;
  },
  methods: {
    /* "public" methods */
    sendWidgetMessage(target, type, data) {
      if (this._widgetPopoverInstance) {
        this._widgetPopoverInstance.postMessage({
          type,
          data,
          target
        }, window.location.origin);
      }
    },
    sendOpenerWidgetMessage(target, type, data) {
      if (window.opener) window.opener.postMessage({
        type,
        data,
        target
      }, window.location.origin);
    },
    setCloseWidgetOnExit(val) {
      this._closeWidgetOnExit = val;
    },
    closeWidgetPopover() {
      if (!this._closeWidgetOnExit) return;
      if (this._widgetPopoverInstance) {
        this._widgetPopoverInstance.close();
        this._widgetPopoverInstance = null;
      }
    },
    /* "private" methods */
    _bindWidgetWindowMessage() {
      window.addEventListener("message", this._receiveWindowMessage, false);
    },
    _unbindWidgetWindowMessage() {
      window.removeEventListener("message", this._receiveWindowMessage);
    },
    _receiveWindowMessage(event) {
      var _context, _this$handleMessage;
      if (event.origin !== window.location.origin || !_includesInstanceProperty(_context = this._validEvents).call(_context, event.data.type)) return;
      return (_this$handleMessage = this.handleMessage) == null ? void 0 : _this$handleMessage.call(this, event.data);
    }
  },
  mounted() {
    this._bindWidgetWindowMessage();
  },
  beforeDestroy() {
    this.closeWidgetPopover();
  },
  deactivated() {
    this.closeWidgetPopover();
  },
  destroyed() {
    this._unbindWidgetWindowMessage();
  }
};